import { Component, Element, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'pnk-navigation-item',
  styleUrl: 'pnk-navigation-item.css',
})
export class PnkNavigationItem {
  @Element() host!: HTMLElement;

  @Prop({ mutable: true }) section: string = '';

  @Prop({ mutable: true, reflect: true }) selected: boolean = false;

  @Event() changed!: EventEmitter<string>;

  handleClick = () => {
    let navigationItems: HTMLPnkNavigationItemElement[] = [];
    console.log(this.host.parentElement);
    if (this.host.parentElement) {
      navigationItems = Array.from(this.host.parentElement.children).filter(el => el.tagName === 'PNK-NAVIGATION-ITEM') as HTMLPnkNavigationItemElement[];
    }

    navigationItems.forEach(item => {
      item.selected = false;
    });

    this.selected = true;

    this.changed.emit(this.section);
  };

  render() {
    return (
      <div class={`${!this.selected ? 'selected' : ' pnk-font-bold'} `} onClick={this.handleClick}>
        <div class={`pnk-flex pnk-flex-row pnk-gap-3 pnk-items-center`}>
          <div class={`${!this.selected ? 'selected' : 'pnk-bg-accent pnk-w-4 pnk-h-4 pnk-rounded-full'}`}></div>
          <div class=" hover:pnk-text-primary-base">{this.section}</div>
        </div>
        <slot />
      </div>
    );
  }
}
